import ReactDOMServer from 'react-dom/server'
import './filepicker.css'
import './dropzone.css'
import {Modal} from 'react-bootstrap'
import styles from './ImportModal.css'
import Dropzone from 'react-dropzone-component'
import * as action from 'actions'
import * as apiS3 from 'api/s3'
import {delay} from 'redux-saga'
import * as apiProfile from 'api/profile'
import * as apiOutlet from 'api/outlets'
import * as actNotif from 'actions/notifications'
import FormData from 'form-data'
import InformationModal from './InformationModal'
import * as mpLibrary from 'mixpanel/library/list'
import {
  V1_IMPORT_LIBRARY_TEMPORARY
} from 'api/ingredients/library/constants'
import {
  V1_IMPORT_ITEMS_TEMPORARY
} from 'api/items/constants'
import ConfirmImportModal from './ConfirmImportModal'
import ConfirmationAfterUploadModal from './ConfirmationAfterUploadModal'

class ImportModal extends React.Component {
  static WAIT_FOR_FILE = 'wait_for_file'
  static PROCESSING = 'processing'
  static UPLOAD_ERROR = 'upload_error'
  static CONFIRM_IMPORT = 'confirm_import'
  static CONFIRM_IMPORT_AFTER_UPLOAD = 'confirm_import_after_upload'
  static SHOW_IMPORT_MODAL = 'show_import_modal'
  static VALIDATING = 'validating'

  constructor (props) {
    super(props)
    this.state = {
      file: null,
      act: ImportModal.WAIT_FOR_FILE,
      warnings: [],
      errors: [],
      showInformationModal: false,
      informationModalMessage: '',
      importUrl: ''
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({
        file: null,
        act: ImportModal.WAIT_FOR_FILE,
        errors: []
      })
    }
  }

  render () {
    let componentConfig = {
      iconFiletypes: ['.csv'],
      showFiletypeIcon: true,
      postUrl: 'no-url',
      uploadMultiple: false,
      addRemoveLinks: 'no'
    }
    const reactContext = this
    let djsConfig = {
      previewTemplate: ReactDOMServer.renderToStaticMarkup(
        <div className={styles['preview-import']}>
          <div className='dz-preview dz-file-preview'>
            <div className='dz-details'>
              <div className='dz-file-remove'>
                <a href='#' data-dz-remove>
                  <span className='glyphicon glyphicon-remove-sign' />
                </a>
              </div>
              <div className='dz-filename'><span data-dz-name /></div>
              <strong><div className='dz-size' data-dz-size /></strong>
              <div className='progress'>
                <div className='progress-bar progress-bar-success progress-bar-striped'
                  role='progressbar'
                  aria-valuenow='40' aria-valuemin='0' aria-valuemax='100' />
              </div>
              <img data-dz-thumbnail />
            </div>
          </div>
        </div>
      ),
      autoProcessQueue: false,
      acceptedFiles: '.csv',
      uploadMultiple: false,
      init: function () {
        this.on('addedfile', function (file) {
          if (reactContext.state.file) {
            this.removeFile(reactContext.state.file)
            reactContext.setState({file: null})
          }
          reactContext.setState({
            file,
            act: ImportModal.VALIDATING
          })
          reactContext._validate(file).then((resolve) => {
            // only modify state if the file name is same from before
            // this is used because user can upload another file during validation
            if (this.files && this.files[0] && this.files[0].name === file.name) {
              reactContext.setState({
                act: ImportModal.WAIT_FOR_FILE
              })
            }
          }).catch((reject) => {
            // only modify state if the file name is same from before
            // this is used because user can upload another file during validation
            // and makes current validation invalid
            if (this.files && this.files[0] && this.files[0].name === file.name) {
              reactContext.setState({
                file: null,
                act: ImportModal.WAIT_FOR_FILE,
                showInformationModal: true,
                informationModalMessage: reject
              })
              this.removeFile(file)
            }
          })
        })

        this.on('removedfile', function (file) {
          reactContext.setState({file: null})
        })

        this.on('error', function (file) {
          if (!file.accepted) {
            reactContext.setState({showInformationModal: true, informationModalMessage: 'Only allowed CSV files'})
          }
          this.removeFile(file)
          reactContext.setState({file: null})
        })
      }

    }

    const {namespace, body, header, footer, confirmImportHeader, confirmImportBody} = this.props
    return <div>
      <Modal show={!this.state.showInformationModal && this.state.act !== ImportModal.CONFIRM_IMPORT && this.state.act !== ImportModal.PROCESSING && this.props.show} bsClass={`${this.props.className} import-modal modal`}>
        <Modal.Header>
          {!!header && header}
          {!header && <Modal.Title> Import {this.state.act === ImportModal.UPLOAD_ERROR ? 'Error' : namespace} </Modal.Title>}
        </Modal.Header>
        <Modal.Body className='modal-body no-padding'>
          {!!body && body}
          {!body && <div className={this.state.act === ImportModal.UPLOAD_ERROR ? styles['error-body-wrapper'] : ''}>
            {this._showDropzoneBody() && <div className={styles['description'] + ' text-left'}>
              <a className='download-our-template' onClick={this._onClickDownloadTemplate}>Download Our Template</a> {this._description()}
            </div>}
            {this._showDropzoneBody() && <div className='box-dropzone'>
              <Dropzone
                className={styles['dropzone-area']}
                config={componentConfig}
                djsConfig={djsConfig}
              >
                <div className='dz-default dz-message' />
              </Dropzone>
            </div>}
            {this.state.act === ImportModal.UPLOAD_ERROR && this._renderErrors()}
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          {!!footer && footer}
          {!footer && <div>
            <span className='pull-left'>
              {this._showBackButton() && <a className='btn btn-default' onClick={this.props.onBack}>Back</a> }
              <a className='btn btn-default' onClick={this.props.onCancel}>Cancel</a>
            </span>
            <span className='pull-right'>
              {this._showUploadButton() && <a
                className={`btn btn-primary`}
                disabled={this._disableUploadButton()}
                onClick={(this._disableUploadButton()) ? '' : this._confirmBeforeUpload}
              >
                Upload
              </a>}
              {this._showTryAgainButton() && <a
                className={'btn btn-primary'}
                onClick={this._onClickTryAgain}
              >
                Try Again
              </a>}
            </span>
          </div>}
        </Modal.Footer>
      </Modal>
      <InformationModal
        show={this.state.showInformationModal}
        onHide={this._onHideInformationModal}
        message={this.state.informationModalMessage}
      />
      <ConfirmImportModal
        show={this.state.act === ImportModal.CONFIRM_IMPORT}
        onCancel={this.props.onCancel}
        onConfirm={this._onUpload}
        body={confirmImportBody}
        header={confirmImportHeader}
      />
      <ConfirmationAfterUploadModal
        show={this.state.act === ImportModal.CONFIRM_IMPORT_AFTER_UPLOAD}
        onCancel={this._onClickTryAgain}
        onConfirm={this._onUpload}
        body={this._renderWarnings()}
        header={this.props.afterUploadConfirmModalHeader}
      />
    </div>
  }

  _showDropzoneBody = () => {
    return (this.state.act === ImportModal.WAIT_FOR_FILE || this.state.act === ImportModal.PROCESSING || this.state.act === ImportModal.VALIDATING)
  }

  _disableUploadButton = () => {
    return this.state.act === ImportModal.PROCESSING || !this.state.file || this.state.act === ImportModal.VALIDATING
  }

  _onHideInformationModal = () => {
    this.setState({showInformationModal: false})
  }

  _onClickDownloadTemplate = async () => {
    const {dispatch, templateImportUrl, namespace, templatePrefix} = this.props
    dispatch(action.showLoadingSpinner(true))
    try {
      await axios.get(templateImportUrl, {withCredentials: true})
      // begin infinite loop until the import process finished
      let exportFinished = false
      let profile
      while (!exportFinished) {
        await delay(5000)
        const resProfile = await apiProfile.getProfile()
        profile = resProfile.data
        if (!profile.exporting) {
          exportFinished = true
        }
      }
      let pattern = new RegExp(templatePrefix, 'i')
      if (!profile || !pattern.test(profile.export_items_file)) {
        dispatch(actNotif.error('Failed to download ' + namespace + ' template'))
      } else {
        window.location.href = profile.export_items_file
      }
    } catch (error) {
      dispatch(actNotif.error(error.message))
    } finally {
      dispatch(action.showLoadingSpinner(false))
    }
  }

  _confirmBeforeUpload = async () => {
    const {confirmPromiseFunction, dispatch} = this.props
    if (confirmPromiseFunction) {
      dispatch(action.showLoadingSpinner(true))
      const needConfirmation = await confirmPromiseFunction()
      if (needConfirmation) {
        this.setState({
          act: ImportModal.CONFIRM_IMPORT
        })
        dispatch(action.showLoadingSpinner(false))
      } else {
        this._onUpload()
      }
    } else {
      this._onUpload()
    }
  }

  _onUpload = async () => {
    const {dispatch, temporaryImportUrl, importUrl, afterSuccessCallback, onErrorCallback, eventName, pathImporting, selectedOutletIds, paramAfterUploadConfirm} = this.props
    const {file} = this.state
    dispatch(action.showLoadingSpinner(true))

    try {
      this.setState(
        { act: ImportModal.PROCESSING,
          importUrl: this.state.importUrl ? this.state.importUrl : importUrl
        }
      )
      let s3CallResult = await apiS3.getNew({filename: file.name})
      let response = s3CallResult.data
      let formData = new FormData()
      formData.append('key', response.key)
      formData.append('acl', response.acl)
      formData.append('AWSAccessKeyId', response.aws_access_key_id)
      formData.append('success_action_status', response.success_action_status)
      formData.append('Content-Type', response.content_type)
      formData.append('Cache-Control', response.cache_control)
      formData.append('policy', response.policy)
      formData.append('signature', response.signature)
      formData.append('file', file)
      // upload to S3
      await axios.post(response.url, formData, {})
      // call temporary import url to set the profile this is the current file
      // we import
      await axios.post(temporaryImportUrl, {uploadfile: response.fullUrl}, {withCredentials: true})
      // begin import and validate the data, will return 422 if invalid data exists
      await axios.post(this.state.importUrl, {}, {withCredentials: true})
      // begin infinite loop until the import process finished
      let importFinished = false

      while (!importFinished) {
        await delay(5000)
        let result, resOutlet, resProfile
        if (pathImporting === 'outlet') {
          let outletId = selectedOutletIds.length > 1 ? selectedOutletIds[0] : selectedOutletIds
          resOutlet = await apiOutlet.getOutletById(outletId)
          result = resOutlet.data
        } else if (pathImporting === 'profile') {
          resProfile = await apiProfile.getProfile()
          result = resProfile.data
        }
        if (!result.importing) {
          importFinished = true
          mpLibrary.libraryItemImport({eventName: eventName})
        }
      }

      this.setState(
        {importUrl: ''}
      )

      if (afterSuccessCallback) {
        afterSuccessCallback()
      }
    } catch (responseError) {
      // Confirmation after upload
      let warnings = responseError.response.data.warning

      if (warnings) {
        const importUrlAfterConfirm = this.state.importUrl + paramAfterUploadConfirm
        this.setState({
          warnings,
          importUrl: importUrlAfterConfirm,
          act: ImportModal.CONFIRM_IMPORT_AFTER_UPLOAD
        })
      } else {
        let errorMessage = ''
        let errorCode = responseError.response.status

        // ni gara2 backend ngasihnya beda2 jadi harus if berdasarkan target URL
        // bahkan satu api struktur responsenya pun bisa beda
        if (temporaryImportUrl === V1_IMPORT_LIBRARY_TEMPORARY || temporaryImportUrl === V1_IMPORT_ITEMS_TEMPORARY) {
          errorMessage = responseError.response.data.error.map((error) => {
            if (error.constructor === Array) {
              return `["${error[0]}","${error[1]}"]`
            } else {
              return error
            }
          })
        } else if (responseError.response.data.errors) {
          errorMessage = responseError.response.data.errors
        } else if (responseError.response.data.error) {
          errorMessage = responseError.response.data.error
        } else {
          errorMessage = ["Oops, something isn't right. Please make sure that your file has the right format"]
        }

        let errors = []
        if (typeof errorMessage === 'string') {
          errors = errorMessage.split(',')
        } else {
          // assume array
          errors = errorMessage
        }
        this.setState({
          errors,
          act: ImportModal.UPLOAD_ERROR
        })
        if (onErrorCallback) {
          onErrorCallback(errors, errorCode)
        }
      }
    } finally {
      dispatch(action.showLoadingSpinner(false))
    }
  }

  _onClickTryAgain = () => {
    this.setState({
      errors: [],
      act: ImportModal.WAIT_FOR_FILE,
      file: null,
      importUrl: ''
    })
  }

  _renderErrors = () => {
    const {errors} = this.state
    return <div>
      <div className={styles['description'] + ' text-left'}>
        We Found {errors.length} error(s) in your file. Please correct them and re-upload your file.
      </div>
      <div>
        <ol>
          {errors.map((message, i) => {
            return <li key={i}><span className={styles['list-type']}>{i + 1}. </span><strong className='text-error'><span className='text-red'>{message}</span></strong></li>
          })}
        </ol>
      </div>
    </div>
  }

  _renderWarnings = () => {
    const {warnings} = this.state
    return <div className={styles['warning-body-wrapper']}>
      <div className={styles['description'] + ' text-left'}>
        {this.props.afterUploadConfirmModalSubHeader}
      </div>
      <div>
        <ol>
          {warnings.map((message, i) => {
            const renderMessage = []
            message.map((subMessage, is) => {
              if (is === 0) {
                renderMessage.push(<li className={styles['warning-list']} key={i}><span className={styles['list-type']}>{i + 1}. </span><strong className='text-error'><span>{message[0]}</span></strong></li>)
              } else {
                renderMessage.push(<li className={styles['warning-list']}>&emsp;<strong className='text-error'><span className='text-red'>{subMessage}</span></strong></li>)
              }
            })
            return renderMessage
          })}
        </ol>
      </div>
    </div>
  }

  _validate = (file) => {
    return new Promise((resolve, reject) => {
      const element = $('.progress')
      $(element).css('width', '0%').show()
      /* global FileReader */
      const reader = new FileReader()
      const reactContext = this
      const { validate } = this.props
      reader.readAsText(file)
      reader.onload = function (event) {
        // HACK => because sometimes windows has different code in newline so we change windows new line into universal string newline
        let csv = event.target.result.replace(/\r/g, '\n').replace(/\n\n/g, '\n')
        let resultOBject = $.csv.toArrays(csv)
        let resultLength = resultOBject.length

        let errorMessage = null
        const headers = reactContext.props.csvHeaders
        // https://mokapos.atlassian.net/browse/FD-1500
        // validasi header dilakukan lebih dahulu sebelum validasi empty file
        // kalo urutan validasi header dan empty file diubah lagi
        // please reconsider this ticket
        if (!errorMessage && headers && headers.length > 0) {
          let isSame = true
          isSame = isSame && resultOBject[0] && resultOBject[0].length > 0
          isSame = isSame && resultOBject[0].slice(0, headers.length).every(function (element, index) {
            return element === headers[index]
          })
          if (!isSame) {
            errorMessage = 'Invalid format, upload process failed. Please re-download the template and try again'
          }
        }
        if (!errorMessage && resultLength > 2501) {
          errorMessage = `Please upload less than 2500 ${reactContext.props.filterNamespace}`
        }
        if (!errorMessage && resultLength <= 1) {
          errorMessage = `${reactContext.props.filterNamespace} can't be empty`
        }
        if (!errorMessage && validate !== undefined && validate(resultOBject)) {
          errorMessage = 'Invalid stock alert value ' + validate(resultOBject)[0].cell + ', ' + validate(resultOBject)[0].message + ''
        }

        const MAX_COUNTER = 25
        for (let i = 1; i <= MAX_COUNTER; i++) {
          setTimeout(() => {
            $(element).css('width', i * (108 / MAX_COUNTER) + '%')
            if (i === MAX_COUNTER) {
              if (errorMessage) {
                reject(errorMessage)
              } else {
                resolve(true)
              }
              $(element).css('width', '0%')
            }
          }, i * 108)
        }
      }
    })
  }

  _showUploadButton = () => {
    return this.state.act === ImportModal.WAIT_FOR_FILE || this.state.act === ImportModal.PROCESSING || this.state.act === ImportModal.VALIDATING
  }

  _showTryAgainButton = () => {
    return this.state.act === ImportModal.UPLOAD_ERROR
  }

  _showBackButton = () => {
    return this.state.act === ImportModal.WAIT_FOR_FILE && !!this.props.onBack || this.state.act === ImportModal.VALIDATING
  }

  _description = () => {
    const {namespace} = this.props
    if (namespace === 'adjustment') {
      return <span>file to adjust the the actual stock of your inventory in bulk. To optimize performance, we can only process 2500 adjustments at a time.If you have any questions on how to bulk import your adjustments, please send an email to support@mokapos.com.</span>
    } else {
      return <span> file and add your {namespace} information to upload {namespace} in bulk.
            To optimize performance, we can only process 2500 items at a time.
            If you have any questions on how to bulk import your {namespace}, please send an email to support@mokapos.com.</span>
    }
  }
}

ImportModal.propTypes = {
  dispatch: React.PropTypes.func,
  templateImportUrl: React.PropTypes.string,
  temporaryImportUrl: React.PropTypes.string,
  importUrl: React.PropTypes.string,
  // if not provided, there will be no back button
  onBack: React.PropTypes.func,
  afterSuccessCallback: React.PropTypes.func,
  // will be called with (errors) where errors is array of error
  onErrorCallback: React.PropTypes.func,
  show: React.PropTypes.bool,
  onCancel: React.PropTypes.func,
  // adjustment, library, customers, etc...
  namespace: React.PropTypes.string,
  templatePrefix: React.PropTypes.string,
  // if provided it will override modal body
  body: React.PropTypes.object,
  // if provided it will override modal footer
  footer: React.PropTypes.object,
  // if provided it will override modal header
  header: React.PropTypes.object,
  // header for confirm import modal. doesn't needed if confirmPromiseFunction is not provided
  confirmImportHeader: React.PropTypes.object,
  // body for confirm import modal. doesn't needed if confirmPromiseFunction is not provided
  confirmImportBody: React.PropTypes.object,
  // function that return promise. must return true (must be confirmed) or false (doesn't need to be confirmed)
  confirmPromiseFunction: React.PropTypes.func,
  // items or ingredients
  filterNamespace: React.PropTypes.string,
  csvHeaders: React.PropTypes.array,
  // for downloading import result. Should be 'profile' (for non-outlet related like import customer) or 'outlet' (outlet-related like import item library)
  pathImporting: React.PropTypes.string,
  // for deciding outlets. Mandatory if 'pathImporting' == 'outlets'
  selectedOutletIds: React.PropTypes.array
}

export default ImportModal



// WEBPACK FOOTER //
// ./app/components/ImportModal/ImportModal.js